import { api } from './api';
import type { Store } from '@/types';
import type { StoreProfileFormData } from '@/lib/validators';

export const merchantService = {
  // Store operations
  getStore: async (storeId: string): Promise<Store> => {
    const { data } = await api.get<Store>(`/merchants/me/stores/${storeId}`);
    return data;
  },

  updateStore: async (storeId: string, data: StoreProfileFormData): Promise<Store> => {
    const { data: response } = await api.put<Store>(`/merchants/me/stores/${storeId}`, data);
    return response;
  },

  getMyStores: async (): Promise<Store[]> => {
    const { data } = await api.get<Store[]>('/merchants/me/stores');
    return data;
  },
};
